import { atom } from "recoil";

export const onboardingTourRequestAtom = atom({
  key: "onboardingTourRequest",
  default: false,
});
